(function ($) {

    let $container;
    let $containerInputSearch;

    /**
     * Инициализирует модуль
     */
    document.addEventListener('DOMContentLoaded', () => {
        $container = $('.filter');
        $containerInputSearch = $('.filter__search-container');

        onTabSelected();
        onFilterTypeChange();
        onFilterTypeClick();
        onGetCurrentFilterType();

    });

    /**
     * Производит подписку на обработку события Получить текущий тип фильтра
     *
     */
    function onGetCurrentFilterType() {
        var subscribeEventName = 'filter-type:get-current';

        $.unsubscribe(subscribeEventName);
        $.subscribe(subscribeEventName, (e, deferred) => {
            console.log('event-received: ' + subscribeEventName);

            deferred.resolve(getCurrentFilterType(), getCurrentSearchedData());
        });
    }

    /**
     * Производит подписку на обработку события выбора вкладки
     *
     */
    function onTabSelected() {
        var subscribeEventName = 'tab-is-selected';

        $.subscribe(subscribeEventName, () => {
            console.log('event-received: ' + subscribeEventName);

            let filterType = getCurrentFilterType();
            onChange(filterType);

            $.publish('filter-type:changed', filterType);
        });
    }

    /**
     * Обработчик события: изменение типа фильтра
     *
     */
    function onFilterTypeChange() {
        $container.off('change', '.filter-type__value');
        $container.on('change', '.filter-type__value', function () {
            onChange(this.value);

            $.publish('filter-type:changed', this.value);
        });
    }

    /**
     * Обработчик события: клик по активному типу фильтра
     *
     */
    function onFilterTypeClick() {
        $container.off('mousedown', '.filter-type__title');
        $container.on('mousedown', '.filter-type__title', (e) => {
            let filterTypeElement = document.getElementById(e.target.getAttribute('for'));
            let filterType = filterTypeElement.value;

            if (!filterTypeElement.checked) {
                return;
            }

            $.publish('filter-elements-delete', [filterType]);
        });
    }

    /**
     * Обработчик события:
     *
     * @param {String} filterType Тип фильтра
     */
    function onChange(filterType) {
        hideAllFilterTypeState();
        showInputSearch(filterType === 'list');
        showFilterTypeState(filterType);
    }

    /**
     * Отображает/скрывает блок содержащий поле поиска
     *
     * @param {Boolean} show
     */
    function showInputSearch(show) {
        if (show) {
            $containerInputSearch.addClass('show');
        } else {
            $containerInputSearch.removeClass('show');
        }
    }

    /**
     * Отображает блок отображающий текущее состояние указанного фильтра
     *
     * @param {String} filterType Тип фильтра
     */
    function showFilterTypeState(filterType) {
        let searchedData = getCurrentSearchedData();
        let $filterTypeState = $container.find(`.filter__tab-content[data-searched-data="${searchedData}"] .filter-type__state[data-filter-type="${filterType}"]`);
        if (!$filterTypeState.length) {
            return;
        }

        $filterTypeState.addClass('show');
    }

    /**
     * Скрывает все блоки отображающие текущее состояние фильтра
     */
    function hideAllFilterTypeState() {
        $container.find('.filter-type__state[data-filter-type]').removeClass('show');
    }

    /**
     * Возвращает тип данных
     *
     * @return {String}
     */
    function getCurrentSearchedData() {
        return $container.find('input[name="searched_data"]').val();
    }

    /**
     * Возвращает текущий тип фильтра
     *
     * @return {String}
     */
    function getCurrentFilterType() {
        let searchedData = getCurrentSearchedData();
        let $tabContent = $container.find('.filter__tab-content[data-searched-data="' + searchedData + '"]');
        let $input = $tabContent.find('input[name*="filter_type"]:checked');

        return $input.val();
    }

})(window.jQuery);